<template>
<div class="container-fluid">
    <div class="d-flex justify-content-end my-3">
      <div class="search-block-btns search-verification-photos d-none d-xl-block">
          <b-button v-if="active_tab === 0" class="mt-3 mt-sm-0"
                    variant="success"
                    title="Одобрить оставшиеся фото для автара"
                    @click="set_all_verification_photo(photos_avatar, 'avatar', 1)">
              <font-awesome-icon :icon="['fas', 'images']" />
              <font-awesome-icon :icon="['fas', 'check']" />
          </b-button>
          <b-button v-if="active_tab === 1" class="mt-3 mt-sm-0"
              variant="success"
              title="Одобрить оставшиеся фото для альбома и автара"
              @click="set_all_verification_photo(photos_album, 'album', 1)">
              <font-awesome-icon :icon="['fas', 'images']" />
              <font-awesome-icon :icon="['fas', 'check']" />
          </b-button>
          <b-button v-if="active_tab === 1" class="mt-3 mt-sm-0"
              variant="warning"
              title="Одобрить оставшиеся фото только для альбома"
              @click="set_all_verification_photo(photos_album, 'album', 2)">
              <font-awesome-icon :icon="['fas', 'images']" />
              <font-awesome-icon :icon="['fas', 'check']" />
          </b-button>
      </div>
</div>
  <b-card no-body>
    <b-tabs content-class="mt-3" justified card align="center"
    nav-class="tabs-photos" v-model="active_tab"
    >
      <b-tab :key="0">
        <template #title>
          <template v-if="photos_avatar.length > 0">
            <strong>Аватар</strong> <b-badge variant="danger">{{photos_avatar.length}}</b-badge>
          </template>
          <template v-else>
            <strong>Аватар</strong> <b-badge variant="success">{{photos_avatar.length}}</b-badge>
          </template>
        </template>

        <b-card-header class="text-center d-none d-xl-block">
          <b-card-title>Проверка фото для <b-badge variant="success">Аватара</b-badge></b-card-title>
        </b-card-header>
        <b-card-body>
          <div class="users-list-block mt-3">
            <div class="row row-cols-sm-2 row-cols-lg-4 row-cols-xl-8 row-cols-1">
              <status-photos-item-component
                v-for="(photo, index) in photos_avatar"
                :key="index"
                :photo_data="photo"
                :current_user="loc_current_user()"
              />
            </div>
          </div>
          <b-alert class="text-center" variant="success" :show="photos_avatar.length === 0">Нет фото для проверки</b-alert>
        </b-card-body>
      </b-tab>
      <b-tab :key="1">
         <template #title>
          <template v-if="photos_album.length > 0">
            <strong>Альбом</strong> <b-badge variant="danger">{{photos_album.length}}</b-badge>
          </template>
          <template v-else>
            <strong>Альбом</strong> <b-badge variant="success">{{photos_album.length}}</b-badge>
          </template>
        </template>
        <b-card-header class="text-center d-none d-xl-block">
          <b-card-title>Проверка фото для <b-badge variant="warning">Альбома</b-badge></b-card-title>
        </b-card-header>
        <b-card-body>
          <div class="users-list-block mt-3">
            <div class="row row-cols-sm-2 row-cols-lg-4 row-cols-xl-8 row-cols-1">
              <status-photos-item-component
                v-for="(photo, index) in photos_album"
                :key="index"
                :photo_data="photo"
                :current_user="loc_current_user()"
              />
            </div>
          </div>
          <b-alert class="text-center" variant="success" :show="photos_album.length === 0">Нет фото для проверки</b-alert>
        </b-card-body>
      </b-tab>
      <b-tab>
         <template #title>
          <template v-if="events.length > 0">
            <strong>События</strong> <b-badge variant="danger">{{events.length}}</b-badge>
          </template>
          <template v-else>
            <strong>События</strong> <b-badge variant="success">{{events.length}}</b-badge>
          </template>
        </template>
        <b-card-header class="text-center d-none d-xl-block">
          <b-card-title>Проверка <b-badge variant="primary">События</b-badge></b-card-title>
        </b-card-header>
        <b-card-body>
          <div class="users-list-block">
            <div class="row">
              <status-photos-events
                v-for="(event, index) in events"
                :key="index"
                :event_data="event"
                :current_user="loc_current_user()"
              />
            </div>
          </div>
          <b-alert class="text-center" variant="success" :show="events.length === 0">Нет события для проверки</b-alert>
        </b-card-body>
      </b-tab>
    </b-tabs>
  </b-card>
</div>
</template>

<script>
import StatusPhotosItemComponent from './StatusPhotosItemComponent';
import StatusEventComponent from './StatusEventsComponent';
import axios from "../../utils/axios";

export default {
  name: 'StatusPhotosPrototype',
  components: {
    'status-photos-item-component': StatusPhotosItemComponent,
    'status-photos-events': StatusEventComponent,
  },
  data() {
    return {
      active_tab: 0,
    }
  },
  props: {
    photos_album: {
      type: Array,
      default() {
        return {};
      },
    },
    current_shift_owner: {
      type: Boolean,
      default() {
        return false
      }
    },
    photos_avatar: {
      type: Array,
      default() {
        return {};
      },
    },
    current_user: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods: {
    loc_current_user(){
      return this.current_user
    },

    set_all_verification_photo(photos, type, status){
      if (photos.length === 0) return;
      let payloads = []
      for (let photo of photos){
          let payload = {
            user_id: photo.user_id,
            photo_id: photo.photo_id,
            status: status,
            main_photo: photo.main_photo,
          };
          payloads.push(payload);
      }

      console.log(payloads)

      return axios.post('/api/v1/status-photos/all-verification-photo', {data: payloads})
        .then((response) => {
          if (type === 'avatar'){
            this.photos_avatar = []
          } else if (type === 'album'){
            this.photos_album = []
          }
        })
        .catch((error) => {
          if (error.hasOwnProperty('response')) {
            // здесь норм сделать отабражение error
            console.log(error.response);
          } else {
            console.log(error);
          }
        });
    },
  },
  computed: {
    events() {
      return this.$store.getters.events;
    },
  },

};
</script>


<style scoped>
.card-header{
  background: none;
}
</style>



// WEBPACK FOOTER //
// src/components/users/StatusPhotosComponent.vue